/* RAVU · página de combo (comportamento de prototipo/combo.html)
   - opções do kit (variantes), quantidades do kit acompanham a opção
   - sabor de cada pote de whey (com 2 potes, um de cada): vai para o pedido como "Sabores do whey"
   - tabelas e ingredientes do whey mostram só os sabores escolhidos
   - kits com 2 opções de sabor (Whey e Creatina, 23/10): uma escolha por opção, e a variação certa sai das duas */
(() => {
  const brl = c => (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  const parcela = t => { const p = window.RAVU_CONFIG?.parcelas || 3; return `Ou ${p}x de ${brl(Math.round(t / p))} sem juros`; };
  const comeca = (a, b) => { a = (a || '').toLowerCase(); b = (b || '').toLowerCase(); return !!a && !!b && (a.startsWith(b) || b.startsWith(a)); };

  class RavuCombo {
    constructor(raiz) {
      this.raiz = raiz;
      this.$ = s => raiz.querySelector(s);
      this.$$ = s => [...raiz.querySelectorAll(s)];
      this.d = JSON.parse(this.$('[data-ravu-combo-dados]').textContent);
      const opcoes = [...new Set(this.d.variantes.map(v => v.opcao))];
      this.opcoes = opcoes;
      this.opcao = opcoes[opcoes.length - 1];
      this.wheys = [];
      this.linhaWhey = this.$('[data-kit] [data-whey]');
      this.multi = (this.d.escolhas || []).length > 1;
      this.sel = this.multi ? this.d.escolhas.map(e => e.valores[0]) : [];
      this.carrossel();
      this.$('[data-opcoes]')?.addEventListener('click', e => {
        const b = e.target.closest('[data-opcao]');
        if (!b) return;
        this.opcao = b.dataset.opcao;
        this.$$('[data-opcoes] .qcard').forEach(x => { const on = x === b; x.classList.toggle('on', on); x.setAttribute('aria-checked', on); });
        this.atualizar();
      });
      this.$('[data-sabores]')?.addEventListener('click', e => {
        const b = e.target.closest('[data-f]');
        if (!b) return;
        if (this.multi) this.sel[+b.dataset.pot] = b.dataset.f;
        else this.wheys[+b.dataset.pot] = b.dataset.f;
        this.atualizar();
        if (this.multi) this.fotoDaVariante();
        else this.fotoDoSabor();
      });
      const add = () => this.adicionar();
      this.$('[data-cta]')?.addEventListener('click', add);
      this.$('[data-sticky-add]')?.addEventListener('click', add);
      this.barraFixa();
      this.atualizar();
    }

    carrossel() {
      const janela = this.$('[data-window]');
      if (!janela) return;
      const total = janela.children.length;
      const indice = () => Math.round(janela.scrollLeft / janela.clientWidth);
      const ir = i => janela.scrollTo({ left: janela.clientWidth * Math.max(0, Math.min(total - 1, i)), behavior: 'smooth' });
      this.irFoto = i => ir(i);
      this.$('[data-prev]')?.addEventListener('click', () => ir(indice() - 1));
      this.$('[data-next]')?.addEventListener('click', () => ir(indice() + 1));
      if (total < 2) this.$('[data-next]').hidden = true;
      this.$('[data-thumbs]')?.addEventListener('click', e => { const b = e.target.closest('[data-i]'); if (b) ir(+b.dataset.i); });
      janela.addEventListener('scroll', () => {
        const i = indice();
        this.$$('[data-dots] i').forEach((d, k) => d.classList.toggle('on', k === i));
        this.$$('[data-thumbs] button').forEach((b, k) => b.classList.toggle('on', k === i));
        this.$('[data-prev]').hidden = i === 0;
        this.$('[data-next]').hidden = i >= total - 1;
        this.$('[data-pills]').style.opacity = i === 0 ? 1 : 0;
      }, { passive: true });
    }

    /* ao trocar o sabor do whey, a galeria vai para a foto daquele sabor (pedido do Thiago, 17/10: escolhia Banoffee e
       lá em cima continuava o Chocolate). O 1º sabor volta para a 1ª foto; os outros vão para a foto da variação. */
    fotoDoSabor() {
      if (!this.d.temSabor || !this.irFoto) return;
      const fotos = this.$$('[data-window] > figure');
      if (this.wheys[0] === this.d.sabores[0]) return this.irFoto(0);
      const v = this.variante();
      const i = fotos.findIndex(f => f.dataset.media && +f.dataset.media === v.foto);
      if (i >= 0) this.irFoto(i);
    }

    /* kits com 2 sabores: a galeria vai para a foto do par escolhido (ex.: Whey Banoffee + Creatina Limão) */
    fotoDaVariante() {
      const v = this.variante();
      const i = this.$$('[data-window] > figure').findIndex(f => f.dataset.media && +f.dataset.media === v.foto);
      if (i >= 0 && this.irFoto) this.irFoto(i);
    }

    /* quantidade de cada item conforme a opção ("2 Whey + 1 Creatina") */
    contagem(linha) {
      /* item de sabor fixo conta pela palavra do sabor ("2 Chocolate + 2 Banoffe", "2 Uva + 2 Limão") */
      for (const nome of [linha.dataset.saborFixo, linha.dataset.nome].filter(Boolean)) {
        const m = this.opcao.match(new RegExp(`(\\d+)\\s+${nome}`, 'i'));
        if (m) return +m[1];
      }
      return +linha.dataset.qtd;
    }

    resumoSabores() {
      if (this.multi) return this.sel.join(' + ');
      const cont = {};
      this.wheys.forEach(f => { cont[f] = (cont[f] || 0) + 1; });
      const ks = Object.keys(cont);
      if (!ks.length) return '';
      if (ks.length === 1) return this.wheys.length > 1 ? `${this.wheys.length}× ${ks[0]}` : ks[0];
      return ks.map(f => `${cont[f]} ${f}`).join(' + ');
    }

    variante() {
      const lista = this.d.variantes.filter(v => v.opcao === this.opcao);
      if (this.multi) return lista.find(v => v.sabores.every((s, k) => s === this.sel[k])) || lista[0];
      return (this.d.temSabor && lista.find(v => v.sabor === this.wheys[0])) || lista[0];
    }

    desenharSabores() {
      if (!this.d.temSabor) return;
      const cor = f => this.d.coresSabor[f] || (/choc/i.test(f) ? '#5A3420' : '#E2B26A');
      if (this.multi) {
        /* uma linha por opção de sabor: "Whey" e "Creatina" */
        this.$('[data-sabores]').innerHTML = this.d.escolhas.map((e, k) => `<div class="fl-pot">
          <span class="fl-n">${e.nome}</span>
          <div class="flavors" role="radiogroup" aria-label="Sabor ${e.nome}">${e.valores.map(f => `<button type="button" class="flavor${f === this.sel[k] ? ' on' : ''}" data-pot="${k}" data-f="${f}" role="radio" aria-checked="${f === this.sel[k]}"><i style="background:${cor(f)}"></i>${f}</button>`).join('')}</div>
        </div>`).join('');
        return;
      }
      /* loja oficial: um sabor para todos os wheys do pedido (a variação já define o sabor);
         sem a lista "o que vem no kit" cadastrada, também é 1 escolha só */
      const n = this.linhaWhey && !this.d.saborUnico ? this.contagem(this.linhaWhey) : 1;
      this.wheys = Array.from({ length: n }, (_, k) => this.wheys[k] || this.wheys[0] || this.d.sabores[0]);
      this.$('[data-sabor-titulo]').textContent = n > 1 ? `Sabor de cada whey (${n} potes)` : 'Sabor do whey';
      this.$('[data-sabores]').innerHTML = this.wheys.map((atual, k) => `<div class="fl-pot">
        ${n > 1 ? `<span class="fl-n">${k + 1}º pote</span>` : ''}
        <div class="flavors" role="radiogroup" aria-label="Sabor do ${k + 1}º pote">${this.d.sabores.map(f => `<button type="button" class="flavor${f === atual ? ' on' : ''}" data-pot="${k}" data-f="${f}" role="radio" aria-checked="${f === atual}"><i style="background:${cor(f)}"></i>${f}</button>`).join('')}</div>
      </div>`).join('');
    }

    /* tabelas do whey: as abas de TODOS os sabores ficam visíveis (Chocolate e Banoffee) e a tabela abre no sabor escolhido
       (pedido do Thiago, 17/10: a do Banoffee só aparecia se o cliente escolhesse Banoffee). Os ingredientes seguem só os escolhidos. */
    filtrarFichas() {
      if (!this.d.temSabor || !this.linhaWhey) return;
      if (this.multi) {
        this.$$('[data-kit] [data-escolha]').forEach(l => this.filtrarProduto(l.dataset.item, [this.sel[+l.dataset.escolha]]));
        return;
      }
      this.filtrarProduto(this.linhaWhey.dataset.item, [...new Set(this.wheys)]);
    }

    trocarPote(l, sabor) {
      const img = l.querySelector('[data-kit-pote]');
      if (!img || !sabor) return;
      let mapa = {};
      try { mapa = JSON.parse(l.dataset.potes || '{}'); } catch (e) { return; }
      const chave = sabor.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().split(/\s+/)[0].slice(0, 5);
      const nome = Object.keys(mapa).find(n => n.toLowerCase().includes(chave));
      if (nome && img.dataset.atual !== nome) {
        img.removeAttribute('srcset');
        img.src = mapa[nome];
        img.dataset.atual = nome;
      }
    }

    filtrarProduto(h, escolhidos) {
      const vale = el => escolhidos.some(f => comeca(el.dataset.sabor, f));
      this.$$(`[data-produto="${h}"] [data-fichas]`).forEach(g => {
        const abas = [...g.querySelectorAll('[data-aba]')];
        const paineis = [...g.querySelectorAll('[data-ficha]')];
        abas.forEach(b => { b.hidden = false; });
        const ativo = paineis.find(vale) || paineis[0];
        paineis.forEach(p => { p.hidden = p !== ativo; });
        abas.forEach(b => { const on = ativo && b.dataset.aba === ativo.dataset.ficha; b.classList.toggle('on', on); b.setAttribute('aria-selected', on); });
        const lista = g.querySelector('.sabores');
        if (lista) lista.hidden = paineis.length < 2;
      });
      this.$$(`[data-ingredientes] [data-produto="${h}"]`).forEach(el => { el.hidden = !vale(el); });
    }

    atualizar() {
      this.desenharSabores();
      const resumo = this.resumoSabores();
      const porProduto = {};
      let potes = 0;
      this.$$('[data-kit] [data-item]').forEach(l => {
        const n = this.contagem(l);
        potes += n;
        porProduto[l.dataset.item] = (porProduto[l.dataset.item] || 0) + n;
        l.querySelector('[data-x]').textContent = `${n}×`;
        if (l.hasAttribute('data-whey')) {
          const texto = this.multi ? this.sel[+l.dataset.escolha] : resumo;
          if (texto) l.querySelector('[data-sabor-texto]').textContent = texto;
          /* pote do sabor escolhido (25/10): acha no nome do arquivo a 1ª palavra do sabor (uva, limao, choco, banof) */
          const sabor = this.multi ? this.sel[+l.dataset.escolha] : this.wheys[0];
          this.trocarPote(l, sabor);
        }
      });
      /* cartões de baixo: soma do mesmo produto (Kit Whey: 2 Chocolate + 2 Banoffe = 4× Whey) */
      Object.entries(porProduto).forEach(([h, n]) => { const card = this.$(`[data-card-qtd="${h}"]`); if (card) card.textContent = `${n}×`; });
      const tp = this.$('[data-total-potes]');
      if (tp && potes) tp.textContent = potes;
      this.filtrarFichas();
      const v = this.variante();
      const pct = v.cheio > v.preco ? Math.round((1 - v.preco / v.cheio) * 100) : 0;
      const eco = this.d.ocultarEconomia ? 0 : v.cheio - v.preco;
      this.$('[data-pills]').innerHTML = [pct ? `${pct}% OFF` : '', eco > 0 ? `Economize ${brl(eco)}` : '', this.d.unico ? `${potes || this.d.potes} potes` : `${this.d.produtos} produtos`]
        .filter(Boolean).map(t => `<span>${t}</span>`).join('');
      this.$('[data-summary]').innerHTML = `<div class="chips2">${pct ? `<span class="off">${pct}% OFF</span>` : ''}${eco > 0 ? `<span>Economize ${brl(eco)}</span>` : ''}</div><div class="tot">${v.cheio > v.preco ? `De <s>${brl(v.cheio)}</s>` : 'total'}<b>${brl(v.preco)}</b></div>`;
      this.$('[data-payline]').textContent = `${parcela(v.preco)} · Pix e boleto`;
      this.$('[data-sticky-total]').textContent = brl(v.preco);
      this.$('[data-sticky-nome]').textContent = [this.opcoes.length > 1 ? this.opcao : '', resumo].filter(Boolean).join(' · ') || this.d.nome;
      const cta = this.$('[data-cta]');
      if (cta && !v.disponivel) cta.disabled = true;
    }

    async adicionar() {
      const v = this.variante();
      const item = { id: v.id, quantity: 1 };
      const resumo = this.resumoSabores();
      if (this.d.temSabor && new Set(this.wheys).size > 1) item.properties = { 'Sabores do whey': resumo };
      const botoes = this.$$('[data-cta], [data-sticky-add]');
      const erro = this.$('[data-erro]');
      erro.hidden = true;
      botoes.forEach(b => b.classList.add('is-loading'));
      try {
        await window.RAVU.carrinho.adicionar([item]);
      } catch (e) {
        erro.textContent = e.message;
        erro.hidden = false;
      } finally {
        botoes.forEach(b => b.classList.remove('is-loading'));
      }
    }

    barraFixa() {
      const barra = this.$('[data-sticky]'), cta = this.$('[data-cta]');
      if (!barra || !cta) return;
      new IntersectionObserver(([e]) => {
        const mostrar = !e.isIntersecting && e.boundingClientRect.top < 0;
        barra.classList.toggle('show', mostrar);
        barra.setAttribute('aria-hidden', !mostrar);
        document.body.classList.toggle('has-sticky', mostrar);
      }).observe(cta);
    }
  }

  const iniciar = () => document.querySelectorAll('[data-ravu-combo]:not([data-pronto])').forEach(raiz => {
    try { new RavuCombo(raiz); raiz.dataset.pronto = ''; } catch (e) { console.error('RAVU · combo:', e); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();
